<template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i> Actualiser
        </button>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-4">
        <label>Mois</label>
        <input
          type="month"
          v-model="selectedMonth"
          class="form-control"
          @change="loadSalaries"
        />
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <button @click="printAllSalarySlips" class="btn btn-success">
          <i class="bi bi-printer"></i> Imprimer toutes les fiches de salaire
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Employé</th>
          <th scope="col">Jours travaillés</th>
          <th scope="col">Salaire</th>
          <th scope="col">Brute/26</th>
          <th scope="col">Salaire Net</th>
          <th scope="col">Avance</th>
          <th scope="col">Consommation</th>
          <th scope="col">Reste à payer</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(salary, index) in salaries"
          :key="salary.employee_reference"
        >
          <td>{{ salary.employeeNumber }}</td>
          <td>{{ salary.employee_fullName }}</td>
          <td>{{ salary.daysWorked }}</td>
          <td>{{ formatNumber(salary.salary) }} DH</td>
          <td>{{ formatNumber(salary.grossPerDay) }} DH</td>
          <td>{{ formatNumber(salary.netSalary) }} DH</td>
          <td>{{ formatNumber(salary.advance) }} DH</td>
          <td>{{ formatNumber(salary.consumption) }} DH</td>
          <td>
            <strong>{{ formatNumber(salary.remainingToPay) }} DH</strong>
          </td>
          <td>
            <button
              @click="printSalarySlip(salary.employee_reference)"
              class="btn btn-sm btn-primary"
            >
              <i class="bi bi-printer"></i> Imprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}`;
    return {
      selectedMonth: currentMonth,
    };
  },
  computed: {
    ...mapGetters("attendance", {
      salaries: "getSalaries",
    }),
  },
  mounted() {
    this.loadSalaries();
  },
  methods: {
    async loadSalaries() {
      if (!this.selectedMonth) {
        this.$toast.error("Veuillez sélectionner un mois");
        return;
      }
      const [year, month] = this.selectedMonth.split("-");
      try {
        await this.$store.dispatch("attendance/getSalaries", { month, year });
      } catch (error) {
        console.error("Error loading salaries:", error);
        // Error is already handled by the store action
      }
    },
    refresh() {
      this.loadSalaries();
    },
    formatNumber(number) {
      if (!number) return "0,00";
      return parseFloat(number).toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async printSalarySlip(employeeReference) {
      if (!this.selectedMonth) {
        this.$toast.error("Veuillez sélectionner un mois");
        return;
      }
      const [year, month] = this.selectedMonth.split("-");
      await this.$store.dispatch("attendance/printSalarySlip", {
        employeeReference,
        month,
        year,
      });
    },
    async printAllSalarySlips() {
      if (!this.selectedMonth) {
        this.$toast.error("Veuillez sélectionner un mois");
        return;
      }
      const [year, month] = this.selectedMonth.split("-");
      await this.$store.dispatch("attendance/printAllSalarySlips", {
        month,
        year,
      });
    },
  },
};
</script>
